// Packages
import htmr from 'htmr'

// Redux
import { useAppSelector } from '@redux/hooks'

// Components
import { Box, Flex, Text } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'
import FacebookReviewCard from '@components/v25/es/ft1/cards/review/facebook-review/FacebookReviewCard'

// Data
import data from '@data/v25/es/ft1/facebook-reviews.json'

// Helpers
import { displayExchangedPrice } from '@helpers/exchangeRate'

const FacebookReviews = () => {
  const { exchangeRate, currency, currencyLoaded } = useAppSelector(
    (state) => state.visitor
  )

  return (
    <Section padding={[0, 0, 64]}>
      <Box>
        <Text
          tagName="h2"
          variant="title-2"
          align="center"
          transform="capitalize"
          spacing={{ sm: 32 }}
        >
          Amado por miles de miembros en todo el mundo
        </Text>

        <Flex flexDirection="column" rowGap={{ sm: 24 }}>
          {data.map((review) => (
            <FacebookReviewCard key={review.name} {...review}>
              {htmr(review.text)}
              {review.price
                ? displayExchangedPrice({
                    value: review.price,
                    exchangeRate,
                    currency,
                    loaded: currencyLoaded
                  })
                : ''}
              {review.textEnd ? htmr(review.textEnd) : ''}
            </FacebookReviewCard>
          ))}
        </Flex>
        <div id="faq-anchor" />
      </Box>
    </Section>
  )
}

export default FacebookReviews
